// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3aDZQ","modalForm":"UpgradeEpcsModal_modalForm__3l4JG","modalFooter":"UpgradeEpcsModal_modalFooter__1VCoI"};